<template>
  <el-tooltip
    :disabled="text === undefined || text === '' || text === null"
    effect="dark"
    placement="top"
    content="复制"
    :open-delay="200"
  >
    <i v-show="text" class="el-icon-document-copy tb-hover-show" @click="copy" />
  </el-tooltip>
</template>

<script>
export default {
  props: {
    text: String
  },
  data() {
    return {
    }
  },
  methods: {
    copy() {
      this.$copyText(this.text).then(res => {
        this.$message.success('复制成功！')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-icon-document-copy{
  margin-left: 4px;
  color: $main-color;
  cursor: pointer;
}
</style>
